var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"filter-pill",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),_vm._v(" "),_c('CloseIcon',{staticClass:"fill-primary icon-size-sm"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }